import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GameIcons } from '../styles/GameIcons';
import '../styles/GameStyleUI.css';

const navButtons = [
  {
    label: 'Learn',
    icon: <GameIcons.Rocket size={24} color="#fff" className="drop-shadow" />,
    to: '/student/learning',
    gradient: 'from-green-400 to-green-500',
  },
  {
    label: 'Practice',
    icon: <GameIcons.Lightning size={24} color="#fff700" className="drop-shadow" />,
    to: '/student/practice',
    gradient: 'from-blue-400 to-blue-500',
  },
  {
    label: 'Progress',
    icon: <GameIcons.Medal size={24} color="#FFD700" className="drop-shadow" />,
    to: '/student/progress',
    gradient: 'from-yellow-400 to-yellow-500',
  },
  {
    label: 'Leaders',
    icon: <GameIcons.Crown size={24} color="#fff" className="drop-shadow" />,
    to: '/student/leaderboard',
    gradient: 'from-purple-400 to-purple-600',
  },
];

const GameNavHeaderButtons: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <nav className="flex gap-2 items-center">
      {navButtons.map((btn) => {
        const isActive = location.pathname.startsWith(btn.to);
        return (
          <button
            key={btn.label}
            onClick={() => navigate(btn.to)}
            className={`px-4 py-2 flex items-center gap-2 rounded-lg text-base font-bold bg-gradient-to-br ${btn.gradient} bg-opacity-80 shadow-sm border border-white/30 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/40 hover:scale-105 hover:-translate-y-0.5 ${isActive ? 'ring-2 ring-yellow-400' : ''}`}
            style={{ minWidth: 80, fontFamily: 'Fredoka, sans-serif', letterSpacing: '0.03em', color: '#fff' }}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="mr-1 flex items-center">{btn.icon}</span>
            <span className="text-white font-bold drop-shadow-sm" style={{color:'#fff', fontSize: '1rem'}}>{btn.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default GameNavHeaderButtons;
